import React, { useContext } from 'react';
import EditableAttribute from '../../../../../../../../../../../Components/Attributes/EditableAttribute/EditableAttribute';
import {
  getAssociationSafe,
  getAttributeSafe,
} from '../../../../../../../../../../../Components/Urval/Utils/urvalUtils';
import clientAvenyModel from '../../../../../../../../../../../Model/clientAvenyModel';
import { ModelContext } from '../../../../../../../../../../../Model/ModelContext/ModelContext';
import { IClientBusinessModel } from '../../../../../../../../../../../Types/ClientModelTypes';
import { ValueType } from '../../../../../../../../../../../Utils/Formatters/FormatterTypes';
import { BusinessDataFormContext } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IKontodelTillaggsinfo } from '../../../../../../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import { FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All } from '../../../../../../Queries/_QueryTypes/FakturaDelQuery';
import { AssociationChoice } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/AssociationChoice/AssociationChoice';
import { ObjektLank } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import { findCollection } from '../../../../../../../../../../../Model/avenyModelUtils';
import { TillaggsinfoQuery } from '../../Queries/_QueryTypes/TillaggsinfoQuery';
import { businessDataFormValuesEqual } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataFormHasChanged/businessDataFormHasChanged';
import { getTillaggsinfoValidationErrorMessageFn } from '../../Utils/TillaggsinfoUtils';
import shortid from 'shortid';
import { TEDSelectionOperator } from '../../../../../../../../../../../globalQueryTypes';
import {
  FormUpdateAssociatonType,
  MutationOperation,
} from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { IUIPage } from '../../../../../../../../../../../Types/UrvalTypes';
import { IFieldValidations } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { useIsSmallScreen } from '../../../../../../../../../../../Hooks/useFullscreenView';
import EDBox from '../../../../../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  data: TillaggsinfoQuery | undefined;
  konteringsforslagDisabled: boolean;
  konteringsforslagUpdateId: string;
  konteringsforslagUpdateOperation:
    | MutationOperation.Add_Values
    | MutationOperation.Update_Values;
  onFieldValueChange: (
    fieldname: string
  ) => (
    newValue: any,
    validationErrorMessage?: IFieldValidations | undefined
  ) => void;
  originKonteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null;
  tillaggsinfo: IKontodelTillaggsinfo;
  updatedKonteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All;
}

const konteringsforslagModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRKonteringsForslag;

const ConsumableInventory: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const modelContext = useContext(ModelContext);
  const dataForm = useContext(BusinessDataFormContext);

  const isSmallScreen = useIsSmallScreen();

  const konteringsforslagCollection = findCollection(
    modelContext.avenyCollectionMap,
    'LRKonteringsForslag'
  );

  // Tilläggsinformation för förbrukningsinventarier

  const FIBenamningAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_FI_BENAMNING',
    modelContext.avenyCollectionMap
  );

  const FIBenamningField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_FI_BENAMNING'
  );

  const FIDatumAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_FI_DATUM',
    modelContext.avenyCollectionMap
  );

  const FIDatumField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_FI_DATUM'
  );

  const FIKategoriField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_FI_ANLKAT_ID'
  );

  const FIOmradeField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_FI_OMRADE_ID'
  );

  const FIByggnadField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_FI_BYGGNAD_ID'
  );

  const FICommentAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_FI_KOMMENTAR',
    modelContext.avenyCollectionMap
  );

  const UsedForFIAttribute = getAttributeSafe(
    'ARAnlKat',
    'AnvForFI',
    modelContext.avenyCollectionMap
  );

  const FICommentField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_FI_KOMMENTAR'
  );

  if (!konteringsforslagCollection) {
    return null;
  }

  const attrHasChanged = (attributeName: string) =>
    !businessDataFormValuesEqual(
      (props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[attributeName] as ValueType,
      (props?.originKonteringsforslag as unknown as Record<string, ValueType> | undefined)?.[attributeName] as ValueType | undefined
    );

  const getErrorMessage = dataForm
    ? getTillaggsinfoValidationErrorMessageFn(
        dataForm.formState.validation,
        props.updatedKonteringsforslag.id
      )
    : () => undefined;

  const platsTypAttribute = getAttributeSafe(
    'ARPlats',
    '_typ',
    modelContext.avenyCollectionMap
  );

  const OmradeIDAssoc = getAssociationSafe(
    'ARPlats',
    'Plats',
    modelContext.avenyCollectionMap
  );

  const OmradeAttribute = getAttributeSafe(
    'ARPlats',
    'id',
    modelContext.avenyCollectionMap
  );

  // För kontering
  const konteringsvardeCollection = findCollection(
    modelContext.avenyCollectionMap,
    'EKKonteringsvarde'
  );

  if (!konteringsvardeCollection) {
    return null;
  }

  const FIOmradeUrvalPages: IUIPage[] = props.updatedKonteringsforslag
    ._Associations?.FIOmrade?.id
    ? [
        {
          id: shortid.generate(),
          conditionObjects: [
            {
              modelPath: [],
              attribute: platsTypAttribute,
              id: shortid.generate(),
              type: 'String',
              condition: [
                {
                  id: shortid.generate(),
                  op: TEDSelectionOperator.equals,
                  values: [
                    {
                      id: shortid.generate(),
                      value: 'B', // Byggnad
                    },
                  ],
                },
              ],
            },
            {
              modelPath: [OmradeIDAssoc],
              id: shortid.generate(),
              attribute: OmradeAttribute,
              type: 'String',
              condition: [
                {
                  id: shortid.generate(),
                  op: TEDSelectionOperator.equals,
                  values: [
                    {
                      id: shortid.generate(),
                      value:
                        props.updatedKonteringsforslag._Associations?.FIOmrade
                          ?.id ?? '',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ]
    : [
        {
          id: shortid.generate(),
          conditionObjects: [
            {
              modelPath: [],
              attribute: platsTypAttribute,
              id: shortid.generate(),
              type: 'String',
              condition: [
                {
                  id: shortid.generate(),
                  op: TEDSelectionOperator.equals,
                  values: [
                    {
                      id: shortid.generate(),
                      value: 'B', // Byggnad
                    },
                  ],
                },
              ],
            },
          ],
        },
      ];

  return (
    <>
      {FIBenamningField?.aktiv && (
        <EDBox
          sx={{
            paddingRight: isSmallScreen ? 0 : 1,
            width: isSmallScreen ? '100%' : '50%',
            boxSizing: 'border-box',
          }}
          component="span"
        >
          <EditableAttribute
            collection={konteringsforslagModel}
            attribute={FIBenamningAttribute}
            key={FIBenamningField.fieldName}
            label={FIBenamningField.benamning}
            onChange={props.onFieldValueChange(FIBenamningField.fieldName)}
            value={(props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[FIBenamningField.fieldName] as ValueType}
            editMode
            marker={attrHasChanged(FIBenamningField.fieldName)}
            required={FIBenamningField.obligatorisk}
            tooltip={FIBenamningField.beskrivning ?? undefined}
            disabled={props.konteringsforslagDisabled}
            errorMessage={getErrorMessage(FIBenamningField.fieldName)}
          />
        </EDBox>
      )}
      {FIDatumField?.aktiv && (
        <EDBox
          sx={{
            paddingLeft: isSmallScreen ? 0 : 1,
            width: isSmallScreen ? '100%' : '50%',
            boxSizing: 'border-box',
          }}
          component="span"
        >
          <EditableAttribute
            collection={konteringsforslagModel}
            attribute={FIDatumAttribute}
            key={FIDatumField.fieldName}
            label={FIDatumField.benamning}
            onChange={props.onFieldValueChange(FIDatumField.fieldName)}
            value={(props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[FIDatumField.fieldName] as ValueType}
            editMode
            marker={attrHasChanged(FIDatumField.fieldName)}
            required={FIDatumField.obligatorisk}
            tooltip={FIDatumField.beskrivning ?? undefined}
            disabled={props.konteringsforslagDisabled}
            errorMessage={getErrorMessage(FIDatumField.fieldName)}
          />
        </EDBox>
      )}

      {FIKategoriField?.aktiv && (
        <AssociationChoice
          collectionName="ARAnlKat"
          label={FIKategoriField.benamning}
          onAssociationSelected={suggestion => {
            if (dataForm) {
              const kategori = props.data?.db?.ARAnlKat_All?.find(
                kategori => kategori.id === suggestion?.value
              );

              let updates: FormUpdateAssociatonType[][] = [
                [
                  {
                    operation: 'Ref',
                    associationName: 'FIKategori',
                    values: suggestion
                      ? {
                          id: suggestion?.value,
                          AR_ANLKAT_ID: kategori?.AR_ANLKAT_ID,
                        }
                      : null,
                  },
                ],
              ];

              dataForm.update(updates);
            }
          }}
          value={
            props.updatedKonteringsforslag._Associations?.FIKategori?.id || ''
          }
          headerDefs={['AR_ANLKAT_ID', 'BENAMNING']}
          editMode
          size="large"
          marker={
            props.updatedKonteringsforslag._Associations?.FIKategori?.id !=
            props?.originKonteringsforslag?._Associations?.FIKategori?.id
          }
          required={FIKategoriField.obligatorisk}
          tooltip={FIKategoriField.beskrivning}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(FIKategoriField.fieldName)}
          validValues={{
            urval: {
              pages: [
                {
                  id: shortid.generate(),
                  conditionObjects: [
                    {
                      modelPath: [],
                      attribute: UsedForFIAttribute,
                      id: shortid.generate(),
                      type: 'String',
                      condition: [
                        {
                          id: shortid.generate(),
                          op: TEDSelectionOperator.equals,
                          values: [
                            {
                              id: shortid.generate(),
                              value: 'Y',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          }}
          fullWidth
        />
      )}
      {FIOmradeField?.aktiv && (
        <EDBox
          sx={{
            paddingRight: isSmallScreen ? 0 : 1,
            width: isSmallScreen ? '100%' : '50%',
            boxSizing: 'border-box',
          }}
          component="span"
        >
          <ObjektLank
            collection={konteringsforslagCollection}
            label={FIOmradeField.benamning}
            value={
              props.updatedKonteringsforslag._Associations?.FIOmrade?.id ?? ''
            }
            onAssociationSelected={suggestion => {
              if (dataForm) {
                dataForm.update([
                  {
                    operation: 'Ref',
                    associationName: 'FIOmrade',
                    id: suggestion?.value ?? '',
                    values: suggestion?.value
                      ? {
                          id: suggestion?.value,
                          ...suggestion?.data,
                        }
                      : null,
                  },
                ]);

                if (
                  suggestion?.value !=
                  props.updatedKonteringsforslag._Associations?.FIOmrade?.id
                ) {
                  dataForm.update([
                    {
                      operation: 'Ref',
                      associationName: 'FIByggnad',
                      values: null,
                    },
                  ]);
                }
              }
            }}
            editMode={true}
            fullWidth
            associationName={'FIOmrade'}
            id={
              props.updatedKonteringsforslag._Associations?.FIOmrade?.id ?? null
            }
            data={props.updatedKonteringsforslag}
            size={isSmallScreen ? 'large' : 'medium'}
            marker={
              props.updatedKonteringsforslag._Associations?.FIOmrade?.id !=
              props?.originKonteringsforslag?._Associations?.FIOmrade?.id
            }
            required={FIOmradeField.obligatorisk}
            tooltip={FIOmradeField.beskrivning}
            headerDefs={['PLATS_KOD', 'BENAMNING']}
            disableAssociationLink
            disabled={props.konteringsforslagDisabled}
            errorMessage={getErrorMessage(FIOmradeField.fieldName)}
            validValues={{
              urval: {
                pages: [
                  {
                    id: shortid.generate(),
                    conditionObjects: [
                      {
                        modelPath: [],
                        attribute: platsTypAttribute,
                        id: shortid.generate(),
                        type: 'String',
                        condition: [
                          {
                            id: shortid.generate(),
                            op: TEDSelectionOperator.equals,
                            values: [
                              {
                                id: shortid.generate(),
                                value: 'F', // OMRADE
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            }}
          />
        </EDBox>
      )}
      {FIByggnadField?.aktiv && (
        <EDBox
          sx={{
            paddingLeft: isSmallScreen ? 0 : 1,
            width: isSmallScreen ? '100%' : '50%',
            boxSizing: 'border-box',
          }}
          component="span"
        >
          <AssociationChoice
            collectionName="ARPlats"
            value={
              props.updatedKonteringsforslag._Associations?.FIByggnad?.id ?? ''
            }
            label={FIByggnadField.benamning}
            onAssociationSelected={suggestion => {
              if (dataForm) {
                dataForm.update([
                  {
                    operation: 'Ref',
                    associationName: 'FIByggnad',
                    values: suggestion?.value
                      ? {
                          id: suggestion?.value,
                        }
                      : null,
                  },
                ]);
              }
            }}
            editMode={true}
            fullWidth
            marker={
              props.updatedKonteringsforslag._Associations?.FIByggnad?.id !=
              props?.originKonteringsforslag?._Associations?.FIByggnad?.id
            }
            required={FIByggnadField.obligatorisk}
            tooltip={FIByggnadField.beskrivning}
            headerDefs={['PLATS_KOD', 'BENAMNING']}
            disabled={
              props.konteringsforslagDisabled ||
              !props.updatedKonteringsforslag._Associations?.FIOmrade?.id
            }
            errorMessage={getErrorMessage(FIByggnadField.fieldName)}
            validValues={{
              urval: {
                pages: FIOmradeUrvalPages,
              },
            }}
          />
        </EDBox>
      )}
      {FICommentField?.aktiv && (
        <EditableAttribute
          collection={konteringsforslagModel}
          attribute={FICommentAttribute}
          key={FICommentAttribute.AttributeName}
          label={FICommentField.benamning}
          onChange={props.onFieldValueChange(FICommentAttribute.AttributeName)}
          value={
            (props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[FICommentAttribute.AttributeName] as ValueType
          }
          editMode={true}
          multiline
          marker={attrHasChanged(FICommentAttribute.AttributeName)}
          required={FICommentField.obligatorisk}
          size="large"
          tooltip={FICommentField.beskrivning ?? undefined}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(FICommentField.fieldName)}
        />
      )}
    </>
  );
};

export default ConsumableInventory;
